import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@lsq/nextgen/v2/button';
import TeamsViewMenuCard from '../../shared/components/TeamsViewMenuCard/index';
import { ROUTES_PATH } from '../../../../constants/globalConstant';
import { ReactComponent as Add } from '../../../../assets/svgIcons/lsq_add.svg';

/**
 * Cell renderer for Launchers column in WebTeams table
 */
export const WebLaunchersCell = ({ data, launchersById }) => {
  const navigate = useNavigate();
  const launcherId = data.launcher;

  const handleLauncherCardClick = (id) => {
    navigate(`${ROUTES_PATH.launchBarHomePage}/${id}`);
  };

  const navigateCreateNewLauncher = () => {
    navigate(ROUTES_PATH.launchBarHomePage);
  };

  return launcherId ? (
    <TeamsViewMenuCard
      menu={launchersById[launcherId]}
      cardClickHandler={() => handleLauncherCardClick(launcherId)}
    />
  ) : (
    <Button
      size="xs"
      variant="secondary-gray"
      icon={<Add />}
      onClick={navigateCreateNewLauncher}
      data-testid="add-launcher-button"
      text="Add Launcher"
    />
  );
};
